import { useMemo } from 'react';
import type { DealLibraryItem } from '../../../types/index.ts';
import { getSearchParamsObj } from '../../../utils/getQueryRoute.ts';
import { mapSearchParamsToCriteria } from '../utils/mapSearchParamsToCriteria.ts';

export const useGetCriteria = (dealTemplates: DealLibraryItem[], queryParams: URLSearchParams) => {
  const {
    params: { pageNumber, sort, column, phrase },
  } = getSearchParamsObj(queryParams);

  return useMemo(() => {
    return mapSearchParamsToCriteria({
      pagination: {
        pageNumber: Number(pageNumber) || 1,
        totalCount: dealTemplates.length,
      },
      phrase: phrase || '',
      sort: { column, direction: sort },
    });
  }, [pageNumber, sort, column, phrase, dealTemplates.length]);
};
